import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useListUserScheduledPrompts } from '../../../../../api/denaliAssistant'
import Loading from '../../../../../components/molecules/Loading'
import EditDigestForm from './DigestForm'

function EditDigest ({ scheduledPrompt, onComplete, onCancel }) {
  const { data: schedules, isLoading } = useListUserScheduledPrompts()
  const availableSchedules = useMemo(() => {
    return (schedules?.scheduledPrompts || [])
      .filter(x => !x.isDigest)
      .map(x => ({
        value: x.scheduleId,
        label: x.name,
        data: x
      }))
  }, [schedules])

  if (isLoading) {
    return (
      <Loading />
    )
  }

  return (
    <EditDigestForm
      scheduledPrompt={scheduledPrompt}
      availableSchedules={availableSchedules}
      onComplete={onComplete}
      onCancel={onCancel}
    />
  )
}

EditDigest.propTypes = {
  scheduledPrompt: PropTypes.object,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default EditDigest
